import {createAction, props} from '@ngrx/store';
import {HttpErrorResponse} from '@angular/common/http';
import {DahPaginationModel} from '@common/models/commonHTTP.models';
import {DahLoadingType} from '@common/components-module/core-components.models';
import {Meeting} from '@communication/_common/models/meeting.models';

export const LoadMeetings = createAction(
    '[Meetings] Load List',
    props<{ payload: { loading: DahLoadingType } }>()
);

export const LoadMeetingsSuccess = createAction(
    '[Meetings] Load List Success',
    props<{ payload: { items: Meeting[], pagination: DahPaginationModel } }>()
);

export const LoadMeetingsFailure = createAction(
    '[Meetings] Load List Failure',
    props<{ payload: HttpErrorResponse }>()
);

export const SetMeetingItemLoading = createAction(
    '[Meetings] Set Meeting Item Loading',
    props<{ payload: { id: string, isStart: boolean } }>()
);

export const UpsertMeeting = createAction(
    '[Meetings] Upsert',
    props<{ payload: Meeting }>()
);

export const UpdateMeeting = createAction(
    '[Meetings] Update',
    props<{ payload: Meeting }>()
);

export const DeleteMeeting = createAction(
    '[Meetings] Delete',
    props<{ payload: string }>()
);

export const DeleteSuccess = createAction(
    '[Meetings] Delete Success',
    props<{ payload: string }>()
);

export const DeleteMeetingFailure = createAction(
    '[Meetings] Delete Failure',
    props<{ payload: string }>()
);

export const SetPagination = createAction(
    '[Meetings] Set Pagination',
    props<{ payload: boolean }>()
);

export const MeetingGeneralUpdatedWS = createAction(
    '[Meetings] General Updated WS',
    props<{ payload: string }>()
);

export const SetInitialState = createAction(
    '[Meetings] Set Initial State'
);
